// Animation module

export function initAnimations() {
  const headings = document.querySelectorAll('.text-wipe-reveal');
  if (!headings.length) return;

  prepareTextWipeReveal(headings);
  initTextWipeReveal(headings);

  window.addEventListener('resize', () => {
    headings.forEach((heading) => {
      if (heading.classList.contains('is-animated')) return;
      prepareHeadingLines(heading);
    });
  });
}

function initTextWipeReveal(headings) {
  
  const pendingAnimations = new WeakMap();

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        const timeoutId = pendingAnimations.get(entry.target);
        if (timeoutId) {
          clearTimeout(timeoutId);
          pendingAnimations.delete(entry.target);
        }
        return;
      }

      if (entry.target.classList.contains('is-animated') || pendingAnimations.has(entry.target)) {
        return;
      }

      const timeoutId = window.setTimeout(() => {
        entry.target.classList.add('is-animated');
        pendingAnimations.delete(entry.target);
        observerInstance.unobserve(entry.target);
      }, 200);

      pendingAnimations.set(entry.target, timeoutId);
    });
  }, {
    threshold: 0.4
  });

  headings.forEach((heading) => observer.observe(heading));
}

function prepareTextWipeReveal(headings) {
  headings.forEach((heading) => {
    prepareHeadingLines(heading);
  });
}

function prepareHeadingLines(heading) {
  const sourceText = getHeadingSourceText(heading);
  const lines = measureHeadingLines(heading, sourceText);

  if (!lines.length) return;

  heading.replaceChildren(...lines.map((lineText, index) => createLineElement(lineText, index)));
}

function getHeadingSourceText(heading) {
  if (heading.dataset.h2SourceText) {
    return heading.dataset.h2SourceText;
  }

  const text = Array.from(heading.querySelectorAll('.h2-text'))
    .map((node) => node.textContent.trim())
    .filter(Boolean)
    .join(' ');

  heading.dataset.h2SourceText = text;
  return text;
}

function measureHeadingLines(heading, sourceText) {
  if (!sourceText) return [];

  const words = sourceText.split(/\s+/).filter(Boolean);
  if (!words.length) return [];

  const measure = document.createElement('span');
  measure.className = 'h2-text h2-text--measure';

  words.forEach((word, index) => {
    const wordSpan = document.createElement('span');
    wordSpan.textContent = word;
    measure.append(wordSpan);

    if (index < words.length - 1) {
      measure.append(document.createTextNode(' '));
    }
  });

  heading.append(measure);

  const groupedLines = [];
  let currentLineTop = null;
  let currentWords = [];

  Array.from(measure.querySelectorAll('span')).forEach((wordSpan) => {
    if (currentLineTop === null) {
      currentLineTop = wordSpan.offsetTop;
    }

    if (wordSpan.offsetTop !== currentLineTop) {
      groupedLines.push(currentWords.join(' '));
      currentWords = [];
      currentLineTop = wordSpan.offsetTop;
    }

    currentWords.push(wordSpan.textContent);
  });

  if (currentWords.length) {
    groupedLines.push(currentWords.join(' '));
  }

  measure.remove();

  return groupedLines;
}

function createLineElement(lineText, index) {
  const line = document.createElement('span');
  line.className = 'h2-line';
  line.style.setProperty('--h2-line-index', index);

  const brand = document.createElement('span');
  brand.className = 'h2-bg-brand';
  brand.setAttribute('aria-hidden', 'true');

  const foreground = document.createElement('span');
  foreground.className = 'h2-bg-foreground';
  foreground.setAttribute('aria-hidden', 'true');

  const text = document.createElement('span');
  text.className = 'h2-text';
  text.textContent = lineText;

  line.append(brand, foreground, text);
  return line;
}
